import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'User/GetDocButtonsPermission', method: 'GET', body: null, token: token })
}
